import { APP_PERMISSIONS } from '@exam-center/permission';
import { useHasPermission } from '@shared/permissions';

import { ExamCourseSettingsFormContainer } from '../exam-course-settings-form-container';
import { ExamCourseSettingsReadonlyDetails } from '../exam-course-settings-readonly-details';

interface ExamCourseSettingsDetailsProps {
  examCourseCode: string;
}

export default function ExamCourseSettingsDetails(props: Readonly<ExamCourseSettingsDetailsProps>) {
  const { examCourseCode } = props;
  const canEdit = useHasPermission(APP_PERMISSIONS.ADMIN_EXAM_COURSE_MANAGEMENT.SETTINGS.UPDATE);

  if (canEdit) return <ExamCourseSettingsFormContainer examCourseCode={examCourseCode} />;

  return <ExamCourseSettingsReadonlyDetails examCourseCode={examCourseCode} />;
}
